<template>
	<div class="geofencing-widget-history-map">
		<google-map
			:mode="mapMode"
			:readings="readings"
			:zones="zones.data"
			:selected="selectedReading"
			:estimated="estimatedPosition"
		/>
		<geofencing-timeline
			:readings="readings"
			:alerts="alerts.data"
			:intervalStart="intervalStart"
			:intervalEnd="intervalEnd"
			@selected="onReadingSelected"
			@neighbors="onNeighbors"
		/>
		<div v-if="emptyStateMap()" class="empty">{{ $t('messages.general.no_values_for_this_date') }}</div>
	</div>
</template>

<script>
import * as d3 from '@/utils/d3'
import GoogleMapsLoader from 'google-maps'
import Readings from '@/utils/readings'
import { MAP_MODE_MULTI } from '@/utils/maps'
import GoogleMap from '@/components/maps/GoogleMap'
import GeofencingTimeline from './GeofencingWidgetHistoryMapTimeline'
export default {
	components: {
		GoogleMap,
		GeofencingTimeline
	},
	props: [
		'user_uid',
		'watch_id',
		'readings',
		'intervalStart',
		'intervalEnd'
	],
	data () {
		return {
			zones: {
				loading: false,
				error: null,
				data: []
			},
			alerts: {
				loading: false,
				error: null,
				data: []
			},
			// map mode: multiple readings
			mapMode: MAP_MODE_MULTI,
			// timeline widget
			selectedReading: null,
			estimatedPosition: null,
			estimatedPositionMarker: null,
			interpolatorFunction: null
		}
	},
	computed: {
		positionsMap () {
			const map = new Map()
			this.readings.map(element => {
				map.set(element.id, element)
			})
			return map
		}
	},
	methods: {
		getZones () {
			this.zones.loading = true
			this.zones.data = []
			return this.$api.geofencing.getAll(this, this.user_uid, this.watch_id)
				.then(response => {
					this.$log.info('geofencing history map', 'geofencing.getAll OK', response)()
					this.zones.data = Readings.processZones(response.body)
				}).catch(error => {
					this.$log.error('geofencing history map', 'geofencing.getAll ERROR', error)()
					this.zones.error = error
				}).finally(() => {
					this.zones.loading = false
				})
		},
		getAlerts () {
			this.alerts.loading = true
			this.alerts.data = []
			return this.$api.alerts.getAllResumeByInterval(this, this.user_uid, this.watch_id, Readings.TYPE_GEOFENCING, this.intervalStart, this.intervalEnd)
				.then(response => {
					this.$log.info('geofencing history map', 'alerts.getAllResumeByInterval OK', response)()
					this.alerts.data = response.body
				}).catch(error => {
					this.$log.error('geofencing history map', 'alerts.getAllResumeByInterval ERROR', error)()
					this.alerts.error = error
				}).finally(() => {
					this.alerts.loading = false
				})
		},
		getData () {
			const promiseZones = this.getZones()
			const promiseAlerts = this.getAlerts()
			Promise.all([promiseZones, promiseAlerts])
				.then(() => {
					this.$log.info('geofencing history map', 'getData() OK')()
				}).catch(error => {
					this.$log.error('geofencing history map', 'getData ERROR', error)()
				})
		},
		onReadingSelected (reading) {
			this.selectedReading = reading
		},
		onNeighbors (neighbors) {
			if (neighbors.length === 2) {
				const a = this.positionsMap.get(neighbors[0][0])
				const b = this.positionsMap.get(neighbors[1][0])
				this.interpolatorFunction = d3.interpolateObject({ lat: a.values.latitude, lng: a.values.longitude }, { lat: b.values.latitude, lng: b.values.longitude })
				this.estimatedPosition = this.interpolatorFunction(Math.abs(neighbors[0][1]) / (Math.abs(neighbors[0][1]) + Math.abs(neighbors[1][1])))
			} else {
				this.estimatedPosition = null
			}
		},
		emptyStateMap() {
			return this.readings.length == 0
		}
	},
	beforeCreate () {
		this.$title('Geofencing')
	},
	mounted () {
		GoogleMapsLoader.KEY = this.$root.settings.googleMapsKey
		GoogleMapsLoader.LIBRARIES = this.$root.settings.googleMapsLibraries
		GoogleMapsLoader.load(() => {
			this.getData()
		})
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/readings/geofencing/widgets/history/GeofencingWidgetHistoryMap.vue